import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=708afbfd&"
import script from "./HelpModal.vue?vue&type=script&lang=ts&"
export * from "./HelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./HelpModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports